// pwa-src/components/sign-in/SignInFlow.tsx
import React, { useEffect, useState } from 'react';
import { SignIn } from './SignIn'; // Adjust path
import { toJson } from '../../firebase/firebase';
import { Loading } from '../base/loading/Loading';

export const SignInFlow: React.FC = () => {
  console.log(
    toJson({
      status: 'sign in flow',
    })
  );

  const [delayedRender, setDelayedRender] = useState(false);
  //This is horrible, and is to circumvent a bug in firebase when the auth renders as the app is starting causing a 30 second delay until auth is useable due to a race condition
  //Delaying 500ms will prevent that
  //A better work around would be to use state to access auth and manage any delay in there, but we'll be upgrading firebase-ui soon so not worth the extra effort (yet)
  useEffect(() => {
    setTimeout(() => {
      setDelayedRender(true);
    }, 500);
  }, []);
  if (!delayedRender) {
    return <Loading />;
  }

  return <SignIn />;
};
